// extracted by mini-css-extract-plugin
export default {"container":"PaginationPage_container__Z8tA3","selected":"PaginationPage_selected__bB1Bm"};